import React, { useRef } from 'react'
import Tree from './Tree'
import { StaticQuery, graphql } from 'gatsby'
import { SideBarStyle,SideBarListStyle } from './LeftSidebar.css'
import useOnClickOutside from '../../hooks/useOnClickOutside'


const Sidebar = props => {
  const sidebarRef = useRef();
  useOnClickOutside(sidebarRef,"toggleLeftMenu", () => {document.body.classList.remove("menuOpen")})
  return <div ref={sidebarRef} css={SideBarStyle} >
    <aside className="leftSidebar" {...props}>
      {props.children}
    </aside>
  </div>
}


const LeftSidebar = ({ location }) => 
  <StaticQuery
    query={graphql`
      query {
        allMdx {
          edges {
            node {
              fields {
                slug
                title
              }
              frontmatter{
								defaultExpandedFrom
                defaultExpandedTo
                order
                container
                hideInNavigation
              }
            }
          }
        }
      }
    `}
    render={({ allMdx }) => (
      <Sidebar>
        <ul css={SideBarListStyle}>
          <Tree edges={allMdx.edges} location={location} />
        </ul>
      </Sidebar>
    )}
  />
            

export default LeftSidebar
